import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from "./index";
import { PoiSearch, getPois } from "../api/poisearch";
import { LoadingState } from "../interfaces/loading";
import * as MapDisplayMode from "../constants/mapdisplaymode";
import { IMapOptions } from "../interfaces/mapoptions";

export interface IPoi {
    list: Array<PoiSearch>; // list of loaded POIs
    currentId: string; // ID of current POI?? Appliable?!?
    status: LoadingState;
    error: string | null;
};

// we could have a pre-defined POI. Unlikely!
function initState(): IPoi {
    const mapoptions: IMapOptions = (<any>window).mapOptions;

    const initialState: IPoi = {
        list: [],
        currentId: mapoptions.poiID,
        status: 'idle',
        error: null
    };

    return initialState;
}


export const fetchPois = createAsyncThunk('poi/fetchPois',
    async ({ latlng, term, token }: { latlng: google.maps.LatLngLiteral, term: string, token: string }) => {
        const response = await getPois(latlng, term, token);
        return response;
    });

const poiSlice = createSlice({
    name: 'poi',
    initialState: initState,
    reducers: {
        showResults(state: IPoi, action: PayloadAction) {
            state.currentId = null;
        },
        showPoi(state: IPoi, action: PayloadAction<string>) {
            state.currentId = action.payload;
        },
        setList(state: IPoi, action: PayloadAction<Array<PoiSearch>>) {
            state.list = action.payload;
            state.currentId = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPois.pending, (state: IPoi, action) => {
                state.status = 'loading';
            })
            .addCase(fetchPois.fulfilled, (state: IPoi, action: PayloadAction<Array<PoiSearch>>) => {
                state.status = 'succeeded';
                state.list = action.payload;
            })
            .addCase(fetchPois.rejected, (state: IPoi, action) => {
                state.status = 'failed';
                state.error = 'Loading error';
            })
    }
});

export const {
    showResults,
    showPoi,
    setList
} = poiSlice.actions;

export default poiSlice.reducer;

// custom selectors
export const selectCurrentPoi = (state: RootState): PoiSearch => {
    const poi = state.poi;
    if (!poi.currentId) {
        return null;
    }
    for (let idx = 0; idx < poi.list.length; ++idx) {
        const thispoi = poi.list[idx];
        if (thispoi.result.id == poi.currentId) {
            return thispoi;
        }
    }
    return null;
}

// custom selectors
export const selectPoi = (state: RootState, poiid: string): PoiSearch => {
    const poilist = state.poi.list;
    if (!poiid) {
        return null;
    }
    for (let idx = 0; idx < poilist.length; ++idx) {
        const thispoi = poilist[idx];
        if (thispoi.result.id == poiid) {
            return thispoi;
        }
    }
    return null;
}

export const selectMapDisplayMode = (state: RootState): number => {
    const poi = state.poi;
    if (poi.status == 'succeeded') {
        if (poi.currentId) {
            return MapDisplayMode.POI;
        }
        else {
            return MapDisplayMode.RESULTS;
        }
    }
    else {
        return MapDisplayMode.START;
    }
}
